import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Hand";
const Hand = memo(themed(Icon));
export {
  Hand
};
//# sourceMappingURL=hand.js.map
